<template>
	<div class="FundInfoDetail" >
		<div class="header_ContentBox p-l-10 p-r-10" >
			<i class="zb zb-moneynt Icon" ></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 资金管理 / 资金明细</span>
		</div>
		<div class="companyOperatingRecordBox content_Box box-shadow m-t-15" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="moneyShow">
				<el-row :gutter="10" class="title">
				  <el-col  :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					  <h4>账户余额</h4>
				  </el-col>
				</el-row>
				<el-row :gutter="10" class="content">
				  <el-col  :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					  <div>
						<b class="balance fl">￥{{ taxSources.balance | filterNumber }}</b> 
					  </div>
				  </el-col> 
				</el-row>

			</div>
			<div class="m-t-30">
				<div class="financialDetails_title">
					<b>【{{taxSources.name}}】资金流水记录</b>
				</div>
				<template>
					<el-table :data="waterRecord" stripe style="width: 100%">
						<el-table-column label="操作人" prop="operator" ></el-table-column>
						<el-table-column label="类型" prop="type" > 
							<template slot-scope="{row,$index}">
								<span class="font-Tahoma " v-if="row.type==1"> 提现 </span>
								<span class="font-Tahoma " v-else-if="row.type==2"> 项目下发 </span>
								<span class="font-Tahoma " v-else-if="row.type==3"> 平台结算  </span>
								<span class="font-Tahoma " v-else-if="row.type==4"> 充值  </span>
							</template></el-table-column>
						</el-table-column>
						<el-table-column label="变动金额" >
							<template slot-scope="{row,$index}">
								<span class="font-Tahoma text-color-red" v-if="row.change_type==1">+ {{row.change_amount | toFixed2 | filterNumber }}</span>
								<span class="font-Tahoma text-color-green" v-if="row.change_type==2">- {{row.change_amount | toFixed2 | filterNumber }}</span>
							</template></el-table-column> 
            <el-table-column label="综合税费"  prop="rate_money"> </el-table-column> 
						<el-table-column label="操作时间"  prop="operation_time"> </el-table-column> 
						<el-table-column label="费用描述"  prop="desc"> </el-table-column>
					</el-table>
				</template>
				<!-- 分页 -->
				<div class="block regPagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
					 :page-sizes="pageSize" :page-size="pageSizeNow" layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
		 
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'FundInfoDetail',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				waterRecord:[], //账户余额
				totle_balance:0, //账户总资产
				taxSources:'', //税源地公司
				//	分页
				total: 0, //总数
				pageNum: 1, //当前页
				pageSize: [10, 20, 50, 100,200,500], //每页展示条数
				pageSizeNow: 20, //当前每页多少行
				channel_id:'', //渠道ID
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				}
				this.channel_id = this.$route.query.channel_id;
				this.getBalance(); //获取企业账户
				this.MoneyDetail(); //获取账户流水
				
			}, 
			MoneyDetail(){ //获取账户流水
				let fn = new FormData();
				fn.append('channel_id', this.channel_id);
				fn.append('page', this.pageNum);
				fn.append('page_size', this.pageSizeNow);
				this.$http.post(this.url + '/zhongfy/bank/MoneyDetail',fn).then((res) => {
					let data = res.data;  
					if (data.code == '200') {
						this.waterRecord = data.data.list;
						this.total = data.data.total;
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						return;
					}
				}, (err) => {
					return;
				});
			},
			
			getBalance(){ //获取账户余额
				this.$http.post(this.url + '/zhongfy/company/getPayChannelList').then((res) => {
					let data = res.data;  
					if (data.code == '200') {
						let arr = data.data;     
						let taxSources = arr.filter((val) => {
						  return val.channel_id ==  this.channel_id
						})
						this.taxSources = taxSources[0] ; 
					} else if (data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						return;
					}
				}, (err) => {
					return;
				});
			},
			 
			handleCurrentChange(val) { //切换页数
				this.pageNum = val; 
				this.MoneyDetail();
			},
			handleSizeChange(val) { //切换每页条数
				this.pageSizeNow = val;
				this.pageNum = 1; 
				this.MoneyDetail();
			},
		},
		filters: {
			
		},
	}
</script>

<style scoped>

	.demo-table-expand {
		font-size: 0;
		background: #f5f6fa;
		border: 1px solid #EBEEF5;
		padding: 15px;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.financialDetails_title {
		height: 30px;
		font-size: 16px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		color: #333333;
		margin-bottom: 15px;
	}
	.moneyShow{
		padding-left: 10px;
	}
	.moneyShow .content{
		height: 36px;
		line-height: 36px;
	}
	.moneyShow .title{
		line-height: 40px;
	}
	.moneyShow .content .balance{
		font-size: 30px;
		color: var(--theme-red);
		font-family: 'Impact', sans-serif;
	}
	.moneyShow .content .freeze{
		font-size: 30px;
		color: var(--zfy-blue);
	}
</style>



// WEBPACK FOOTER //
// src/components/FundInfoDetail.vue